import { render, staticRenderFns } from "./DashboardDaysReservations.vue?vue&type=template&id=39c6ad64&scoped=true&"
import script from "./DashboardDaysReservations.vue?vue&type=script&lang=js&"
export * from "./DashboardDaysReservations.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDaysReservations.vue?vue&type=style&index=0&id=39c6ad64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6ad64",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DashboardDaysReservations.vue
// module id = null
// module chunks = 